import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Wrench } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

export function MaintenancePage() {
  return (
    <main
      className="flex min-h-screen items-center justify-center bg-[#030712] px-4 pb-16 pt-24 text-white"
      aria-labelledby="maintenance-title"
    >
      <Helmet>
        <title>Scheduled maintenance - Lighthouse Jobs</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Card className="w-full max-w-xl border-white/10 bg-white/[0.04]">
        <CardContent className="space-y-6 p-10 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-white/10 text-[#f7ef8a]">
            <Wrench className="h-8 w-8" aria-hidden />
          </div>
          <div className="space-y-2">
            <h1 id="maintenance-title" className="text-3xl font-semibold">We&apos;re performing scheduled maintenance</h1>
            <p className="text-sm text-gray-300">
              The Lighthouse apps are temporarily unavailable while we roll out improvements. Candidate profiles,
              employer dashboards, and admin tools will be back shortly.
            </p>
            <p className="text-sm text-gray-400">
              Status updates are posted in-app and via email when service has been restored.
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Button asChild className="bg-gold-gradient text-black hover:brightness-110">
              <Link to="/">Return home</Link>
            </Button>
            <Button asChild variant="outline" className="border-white/20 text-white hover:bg-white/10">
              <Link to="/contact">Notify the Lighthouse team</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
